import React from 'react';

export default function Consent() {
    return (
        <div style={{ padding: 20 }}>
            <h1>Patient Consent</h1>
            <p>Consent form placeholder.</p>
        </div>
    );
}
